/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:23:56
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ඇතුළු කරන්න",
    name2: "වෙන්කිරිමක් සිදුකරන්න",
    name3: "Carlcare සමඟින්, ඔබට ඔබේ ඇනවුම ඕනෑම අවස්ථාවක පරීක්ෂා කළ හැකිය.",
    name4: "",
    name5: "දකුණට ස්ලයිඩ් කරන්න",
    name6: "සනාථ කිරීම සම්පූර්ණ යි",
  },
  order: {
    name1: "උපාංග මාදිලිය තෝරන්න",
    name2: "දෝෂ විස්තරය:",
    name3: "සේවා ගබඩාව තේරීමට තට්ටු කරන්න",
    name4: "සේවා ගබඩාව:",
    name5: "වෙන්කිරීමේ වේලාව:",
    name6: "කරුණාකර ඔබේ උපාංගයේ ගැටළුව විස්තර සහිතව පවසන්න!",
    name7: "පැමිණීමේ වේලාව තේරීමට තට්ටු කරන්න",
    name8: "අපට ඔබ වෙත ළඟා විය හැකි පරිදි කරුණාකර ඔබේ නිවැරදි සබඳතා විස්තර ඇතුළු කරන්න",
    name9: "තිබෙන වෙන් කිරීමේ කාලය පහත පරිදි වේ",
    name10: "ඔබේ දුරකථන අංකය ඇතුළු කරන්න",
    name11: "මිල",
    name12: "පුද්ගලික තොරතුරු:",
    name13: "කරුණාකර ඔබේ නම ඇතුළු කරන්න",
    name14: "යොමු කරන්න",
    name15: "අවලංගු කරන්න",
    name16: "හරි",
  },
  shops: {
    name1: "ඔබ විසින් තෝරන සන්නාමය මත පදනම්ව, පහත දැක්වෙන ගබඩාවලට ඔබට සේවය කිරීමට හැකි වනු ඇත!",
    name2: "තව සිල්ලර වෙළඳසැල්වලට ඉක්මණින් පැමිණේ! අප සමඟ රැඳී සිටින්න!",
  },
  price: {
    name1: "සන්නාමය",
    name2: "අනුකෘතිය",
    name3: "අයිතමය",
    name4: "මිල",
    name5: "මිත්‍රශීලී මතක් කිරීම:",
    name6: "මෙම මිල ගණන් දැන ගැනීම සඳහා පමණක් වන අතර සැබෑ මිල ඔබගේ උපාංගයේ තත්වය අනුවය.",
    name7: "එහි විශේෂ සංකේතයක් නොමැති නම්, මිල ඒකකය දේශීය මුදල් ඒකකයයි.",
    name8: "කණගාටුයි! වත්මන් කලාපය තුළ මිල තොරතුරු නැත.",
    name11:"ශ්‍රම පිරිවැය",
    name12:"සමස්ත මිල",
    name13: "5. ශ්‍රම පිරිවැය \"/\" නම්, ඉන් අදහස් වන්නේ වෙළඳසැලෙන් ශ්‍රම පිරිවැය විමසිය යුතු බවයි.",
    item_main_board: "ප්‍රධාන පුවරුව",
    item_screen_frame: "තිරය (රාමුව)",
    item_screen_screen_frame: "ද්විතීයික තිරය (රාමුව)",
    item_touch_screen: "ස්පර්ශක තිරය",
    item_camera: "\"කැමරාව\"",
    item_fixed_focus_camera: "ස්ථාවර නාභියක් සහිත කැමරාව",
    item_auto_focus_camera: "ස්වයංක්‍රීය නාභියක් සහිත කැමරාව",
    item_screen: "තිරය",
    item_secondary_screen: "ද්විතීයික තිරය",
    item_fingerprint_module: "ඇඟිලි සලකුණු මොඩියුලය",
    item_speaker: "ස්පීකරය",
    item_receiver: "රිසීවරය",
    item_small_board: "කුඩා පුවරුව",
    item_battery_cover: "බැටරි කවරය",
    item_battery: "බැටරිය",
    item_charger: "චාජරය",
    item_usb_cable: "USB කේබලය",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "දත්ත නැත",
    name2: "සේවා සපයන්නා:",
    name3: "සේවා නාමය:",
    name4: "දුරකථනය:",
    name5: "ඇනවුම් ප්‍රමාණය:",
    name6: "සේවා වර්ගීකරණය",
    name7: "සේවා පරිසරය",
    name8: "සේවා ආකල්පය:",
    name9: "සේවා කාර්යක්ෂමතාව:",
    name10: "සේවා ගුණාත්මකභාවය:",
    name11: "පාරිභෝගික තක්සෙරුව",
    name12:"සිට",
    name13:"වසන ලදි",
    name14:'"ලිපිනය":',
    "name6_5": "සේවා වේලාව"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ඇතුළු කරන්න",
    name1: "ප්‍රමුඛතා සේවාව වෙත පිවිසීමට කරුණාකර වෙන් කිරීම පිළිබඳ තිරරූපයක් ලබා ගෙන එය ලදුපතක් ලෙස සුරකින්න.",
    name2: "සාර්ථකව ඉදිරිපත් කරන ලදි",
    name3: "1. දත්ත පිරිසිදු කරන්න",
    name4: "කරුණාකර ඔබේ දුරකථනයේ රහස්‍ය දත්ත පළමුව උපස්ථ කරන්න",
    name5: "2. පවර්-ඔන් රහස්වචනය අක්‍රිය කරන්න",
    name6: "සිල්ලර වෙළඳසැල වෙත යාමට පෙර, කරුණාකර:",
    name7: "සේවා ගබඩාව:",
    name8: "වෙන්කිරීමේ වේලාව:",
    name9: "දෝෂ විස්තරය:",
    name10: "උපාංග මාදිලිය:",
    name11: "ඇනවුම් අංකය:",
    name12: "වෙනත් තොරතුරු",
  },
  title: {
    
    name1: "පහත රටවලට ආධාරක වේ:",
    name2: "මාදිලිය තෝරන්න",
    name3: "වෙන්කිරීම",
    name4: "සේවා ගබඩා විස්තර",
    name5: "සේවා ගබඩාව තෝරන්න",
  },
  error: {
   
    name1: "දත්ත නැත. කරුණාකර ඔබේ අලුත්වැඩියා තොරතුරු පරීක්ෂා කරන්න",
    name2: "තවත් උදව් අවශ්‍ය ද? කරුණාකර අප අමතන්න.",
    name3: "කණගාටුයි, වත්මන් කලාපයෙහි Carlcare මධ්‍යස්ථානයක් නොමැත.",
    name4: "කරුණාකර සේවා මධ්‍යස්ථානයක් පළමුව තෝරන්න",
    name5: "අසාර්ථක වුණි",
    name6: "කරුණාකර උපාංග මාදිලිය පළමුව පරීක්ෂා කරන්න",
    name7: "විස්තර",
    name8: "කරුණාකර ඔබේ අවශ්‍යතා විස්තරාත්මකව විස්තර කරන්න",
    name9: "",
  },
  add1:{
    "name0": "si-rLK",
    "name1": "ඔ බේ ඇණවුම තහවුරු කර තිබේ. අපි ඔ බ පැමිණෙන තෙක් උනන්දුවෙන් බලා සිටිමු.",
    "name2": "නගරය තෝරන්න",
    "name3": "කරුණාකර ඉලක්කම් %1$s ක දුරකථන අංකයක් ඇතුළු කරන්න.",
    "name4": "සතියේ දිනවල පැය ගණන්",
    "name5": "සඳුදා",
    "name6": "අඟහරුවාදා",
    "name7": "බදාදා",
    "name8": "බ්\u200dරහස්පතින්දා",
    "name9": "සිකුරාදා",
    "name10": "සෙනසුරාදා",
    "name11": "ඉරිදා",
    "name12": "රට ඇතුළු කර සොයන්න"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "වෙනත්",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"හරවා යැවීමට තට්ටු කරන්න",
    name3:"ඇණවුම ඇගයීම සඳහා Carlcare යෙදුම විවෘත කරන්න",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"සේවාව තෝරන්න",
    name7:"නොමිලේ පිරිසිදු කිරීම",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "තොරතුරු වැරදියි",
    "cancelReason1": "නියමිත වේලාවට ලඟාවිය නොහැක",
    "cancelReason2": "අනුපිටපත් ඇනවුමකි/මගේ ඇණවුම නොවේ",
    "cancelReason3": "දෝෂය නැවත සිදු නොවේ",
    "cancelReason4": "හුදෙක්පරික්ෂා කිරිම/විමසීම/සිද්ධිය සඳහාය/…",
    "cancelReason5": "ඉහළ මිල",
    "cancelReason6": "අමුද්‍රව්‍යවල හිඟය",
    "cancelReason7": "වෙනස් කළ සේවා නොමැත",
    "cancelReason8": "සාප්පුව ඉතාමත් දුරය",
    "cancelReason9": "සාප්පුව වසා තිබේ",
    "cancelReason10": "සේවා ආකල්පය අයහපත්ය",
    "cancelReason11": "වෙනත් වෙළඳ නාම සඳහා ප්‍රතිස්ථාපනය/අලුත්වැඩියාව",
    "cancelReason12": "වෙළඳසැල සොයාගත නොහැක",
    "cancelReason13": "වෙනත්",
    "cancelOrder": "ඇනවුම අවලංගු කරන්න",
    "reason_dialog_title": "කරුණාකර අවලංගු කිරීම සඳහා වන හේතුව පවසන්න",
    "Cancel": "අවලංගු කරන්න",
    "OK": "හරි",
    "name1": "සත්\u200dයාපන කේතය ඇතුළත් කරන්න",
    "name2": "වැරදි තහවුරු කිරීමේ කේතය",
    "repair_reservation_detail_canceled": "මෙම ඇනවුම අවලංගු කර ඇත!",
    "purchase_cancel_dialog_content": "ඇණවුම අවලංගු කිරීම තහවුරු කරනවා ද?",
    "yes": "ඔව්",
    "no": "නැත"
},
onSiteService:{
  "name1": "අලෙවිසැල තුළ අලුත්වැඩියාව",
  "name2": "ස්ථානය තුළ සේවාව",
  "name3": "අඩවිය මත සේවාව භාවිත කිරීම සඳහා ඔබ විසින් පිහිටීම ක්‍රියාත්මක කළ යුතු ය. කරුණාකර එය නැවතත් ක්‍රියාත්මක කර නැවත උත්සාහ කරන්න.",
  "name4": "ඔබේ ස්ථානය තේරන්න:",
  "name5": "ස්ථානීය ඇණවුම්",
  "name6": "වත්මන් පිහිටීම:",
  "name7": "ලිපිනය:",
  "name8": "නම",
  "name9": "දුරකථනය:"
}
};
